/**
 * Manual program/review logging is status + approximate minutes. Users rarely
 * know exact start/end times, so timestamps are derived for sorting and Fusion
 * timers — not shown in the log modals or primary grid captions.
 */

/** Backfill an approximate start from log time minus reported duration. */
export function approximateStartedAt(
	completedAtIso: string,
	durationMinutes: number | null | undefined
): string | null {
	const minutes = durationMinutes ?? 0;
	if (minutes <= 0) {
		return null;
	}
	return new Date(
		new Date(completedAtIso).getTime() - minutes * 60 * 1000
	).toISOString();
}

/**
 * Keep a measured start (Fusion / in-progress session) when present; otherwise
 * derive an approximate start from completion time and duration.
 */
export function resolveCompletedSessionStartedAt(
	existingStartedAt: string | null | undefined,
	completedAtIso: string,
	durationMinutes: number | null | undefined
): string | null {
	if (existingStartedAt) {
		return existingStartedAt;
	}
	return approximateStartedAt(completedAtIso, durationMinutes);
}

export function formatDurationCaption(
	status: 'pending' | 'in_progress' | 'done',
	durationMinutes: number | null | undefined
): string | null {
	if (status === 'in_progress') {
		return 'In progress';
	}
	if (status === 'done') {
		if (durationMinutes != null && durationMinutes > 0) {
			return `${durationMinutes} min`;
		}
		return 'Completed';
	}
	return null;
}
